import React from "react";
import styled from "styled-components";

// Responsive breakpoints for hero images
export const BREAKPOINTS = {
  mobile: { max: 440 },
  desktop800: { min: 441, max: 899 },
  desktop1200: { min: 900, max: 1399 },
  desktop1600: { min: 1400, max: 1799 },
  desktop2400: { min: 1800 },
} as const;

export const HeroImage = () => {
  return (
    <HeroImageWrapper>
      <div className="hero">
        <picture className="hero__picture" aria-hidden="true">
          <source
            media={`(max-width: ${BREAKPOINTS.mobile.max}px)`}
            srcSet="/images/hero-images/familyMobile-800.webp"
          />
          <source
            media={`(min-width: ${BREAKPOINTS.desktop800.min}px) and (max-width: ${BREAKPOINTS.desktop800.max}px)`}
            srcSet="/images/hero-images/familyFull-800.webp"
          />
          <source
            media={`(min-width: ${BREAKPOINTS.desktop1600.min}px) and (max-width: ${BREAKPOINTS.desktop1600.max}px)`}
            srcSet="/images/hero-images/familyFull-1600.webp"
          />
          <source
            media={`(min-width: ${BREAKPOINTS.desktop2400.min}px)`}
            srcSet="/images/hero-images/familyFull-2400.webp"
          />
          <img
            className="hero__img"
            src="/images/hero-images/familyFull-1200.webp"
            alt=""
            loading="eager"
            fetchPriority="high"
            decoding="async"
          />
        </picture>
      </div>
      <div className="hero__overlay"></div>
    </HeroImageWrapper>
  );
};

const HeroImageWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 100vh;
  grid-area: 1 / 1;
  overflow: hidden;

  .hero {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .hero__bg {
    display: none;
  }

  .hero__picture,
  .hero__img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
  }

  .hero__picture {
    z-index: 0;
    background-color: #2c2e30;
  }

  .hero__img {
    display: block;
    object-fit: cover;
    object-position: center top;
  }

  .hero__overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(12deg, rgba(0, 0, 0, 0.5) 39%, rgba(0, 0, 0, 0) 56%);
    z-index: 1;
  }
`;
